import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';

class Common {
    constructor() {

    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.form-container').validate();

        // phone mask
        //$('.js-phone-input').mask('(000) 000-0000');

        $('#contact-form').on('submit', e => { this.validateForm(e); });

        $('[data-hasdepending="true"]').on('change', e => { this.toggleDependingForm(e); });

        $(".notification-bar-close").click(function () {
            $(".notification-bar").fadeOut(); // Use fadeOut() for a smooth effect
        });

        $('.slick-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
        });

        $('.slick-slider--testimonials').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: true,
        });

        $('.slick-slider--lendingOptions').slick({
            slideToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
        });
        // state specific loans for community lending site
        $('.slick-slider--stateLoans').slick({
            slidetoshow: 4,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidestoshow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidestoshow: 2
                    }
                }
            ]
        });
        $('.slick-slider--stateLoansFeatured').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
        
        $('.slick-slider--stateLoansAll').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        $('#all-programs-tab').on('click', function (event) {
            setTimeout(function () {
                $('.slick-slider--stateLoansAll').slick('setPosition'); // Recalculate positions
            }, 100); // Small delay to ensure tab transition is complete
        });
        $('.slick-slider--reviews').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: false,
            variableWidth: false,
            adaptiveHeight: true,
            dots: true,
        });
        //retail hero slider
        //$('.section-hero--home .slick-slider--hero').slick({
        //    slideToShow: 1,
        //    slidesToScroll: 1,
        //    arrows: true,
        //    //appendArrows: $('.section-hero .slick-dots'),
        //    fade: false,
        //    autoplay: false,
        //    infinite: true,
        //    variableWidth: true,
        //    adaptiveHeight: true,
        //    dots: true,
        //    //appendDots: $('.section-retail .slide-content'),
        //});

        //three column card widget
        $('.slick-slider--cardThreeColumn').slick({
            slideToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: false,
            infinite: false,
            variableWidth: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });
    }

    conditionallyRequiredToggle(parentValue, item) {
        $(item).each((index, formGroup) => {
            let $formInput = $(formGroup).find('.conditionally-required');
            $formInput.attr('required', parentValue);

            if (!parentValue) {
                $formInput.removeClass('input-validation-error');

                let $errorContainer = $formInput.siblings('span.error');
                $errorContainer.removeClass('field-validation-error').addClass('field-validation-valid');
            }
        });
    }

    toggleDependingForm(e) {
        let value = $(e.currentTarget).val();
        let name = $(e.currentTarget).attr('name').replace( 'Form.', '' );

        let questions = $(`[data-dependingquestion="${name}"]`);

        $(questions).each((index, item) => {
            if (Array.isArray(value)) {
                if (value.includes($(item).data('dependinganswer'))) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
            else {
                if (value.toLowerCase().indexOf($(item).data('dependinganswer').toLowerCase()) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }

            //handle depending answer being multiple options
            let dependingAnswer = $(item).data('dependinganswer');
            if (dependingAnswer.includes(',')) {
                const answers = dependingAnswer.split(',');
                if ($.inArray(value, answers) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
        });
    }

    validateForm(e) {
        if ($('#recaptcha_contact')[0] && grecaptcha.getResponse().length === 0) {
            e.preventDefault();
            $('#recaptcha_contact').next().show();
            return false;
        }
        else {
            if ($('#recaptcha_contact')[0]) {
                $('#recaptcha_contact').next().hide();
            }
            return true;
        }
    }
}

export default Common;